import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/base'
import './plugins/chartist'
// import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueCookies from 'vue-cookies'
import axiosInstance from './plugins/axios'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
// import VueConfirmDialog from 'vue-confirm-dialog'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueMask from 'v-mask'
// import Editor from 'vue-editor-js/src'
import Breadcrumbs from './components/Breadcrumbs'
// import VueCompositionAPI from '@vue/composition-api'

import excel from 'vue-excel-export'
Vue.use(excel)

import Bootstrap from 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import Jquery from 'jquery'



// import mainOidc from "./plugins/auth";
import moment from "moment-jalaali";

import { debounce } from "lodash";

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
// import Editor from 'vue-editor-js/src'
// import excel from 'vue-excel-export'
// Vue.use(excel)
Vue.component('date-picker', VuePersianDatetimePicker);

//Vue.use(Editor)
// Vue.use(Editor)
Vue.use(VueMask)
// Vue.use(VueCompositionAPI);
// Vue.use(VueConfirmDialog)
// Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.use(VueToast, {
  position: 'top',
})

Vue.component('bread-crumbs', Breadcrumbs)
Vue.use(VueCookies)
window.axios = axiosInstance
//window.$ = Jquery
Vue.config.productionTip = false
window.debounce = debounce;
window.moment = moment;
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')

